import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {PaymentGatewayService} from "../../../serverService/paymentGatewayService/PaymentGatewayService";
import {SnackbarHelper} from "../../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../../context/SnackBarContext";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {useParams} from "react-router-dom";
import {
    RaikoLabel,
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoSimpleInputOutlined,
    RaikoButtonSecondary,
    RaikoButtonPrimary, RaikoFlexAlignEnd
} from "@moeindal/base-raiko-panel-components";

export default function PaymentGatewayToken() {

    const {id: gateWayId} = useParams()

    const service = new PaymentGatewayService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof gateWayId !== 'undefined') {
            service.getGatewayToken(gateWayId)
                .then(response => {
                    setToken(response.token)
                }).catch(reason => {
                snackbar.showServerErrorMessage(reason)
            }).finally(_ => {

            })
        }
    }, [gateWayId]);


    const [token, setToken] = useState("")

    function handleUpdateToken() {
        if (token.length > 0) {
            loading.show()
            service.updateGatewayToken(gateWayId, token)
                .then(response => {
                    snackbar.showSuccessMessage("بروزرسانی مجوز درگاه با موفقیت انجام شد.")
                }).catch(reason => {
                snackbar.showServerErrorMessage(reason)
            }).finally(_ => {
                loading.hide()
            })
        } else {
            snackbar.showWarningMessage("لطفا مجوز درگاه را به درستی وارد نمایید.")
        }
    }

    function handleTestToken() {
        if (token.length > 0) {
            loading.show()
            service.testGatewayToken(gateWayId)
                .then(response => {
                    if (response.status === "SUCCESS") {
                        snackbar.showSuccessMessage(response.message)
                    } else
                        snackbar.showErrorMessage(response.message)

                }).catch(reason => {
                snackbar.showServerErrorMessage(reason)
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    return (
        <RaikoBaseCardContainer className={css`margin-top: 16px;`}>
            <RaikoGridOneColumn>
                <RaikoLabel text={"مجوز درگاه پرداخت (توکن)"}/>
                <RaikoSimpleInputOutlined
                    labelText={"مجوز درگاه پرداخت"}
                    setValue={setToken}
                    value={token}/>
                <RaikoFlexAlignEnd className={css`gap: 1rem`}>
                    <RaikoButtonSecondary label={"بررسی اتصال"} onClick={handleTestToken}/>
                    <RaikoButtonPrimary
                        label={"بروزرسانی"} onClick={handleUpdateToken}/>
                </RaikoFlexAlignEnd>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>

    )
}